module.exports = {
  "country": "NO",
  "artist": "Kate Gulbrandsen",
  "song": "Mitt Liv",
  "year": "1987",
  "place": "9",
  "spotify": "6m3aPUdYfDUViXNWexf27q"
};